const StudyMixin = {
	computed: {
		sections () {
			let allSections = _.cloneDeep(this.active_study.template.sections);
			if(this.active_study.etudeData.kyaneosData && this.active_study.etudeData.kyaneosData.Lots){
				const numberOfLots = this.active_study.etudeData.kyaneosData.Lots.length;
				if(numberOfLots > 6){
					let sectionTable;
					let indexSectionTable = 0;
					let found = false;
					const numberTableNeeded = Math.floor(numberOfLots / 21);
					while(indexSectionTable < allSections.length && !found){ // search the index of lexique-table section
						found = allSections[indexSectionTable].slug == "scpi-lexique-table";
						sectionTable = allSections[indexSectionTable];
						indexSectionTable++;
					}
					for(let j = 0; j < numberTableNeeded ; j++){
						const sectionToAdd = {...sectionTable};
						sectionToAdd.slug += "-" + (j + 1);
						allSections.splice(indexSectionTable + j, 0, sectionToAdd); // add the section just before the last lexique-table section
					}
					sectionTable.slug += "-0"; // change the default name to help with table's build
				}else{
					allSections = allSections.filter((section) => section.slug !== "scpi-lexique-table");
				}
			}
			return allSections;
		}
	}
};

export default StudyMixin;